module.exports = __webpack_public_path__ + "static/media/loader.93f1b332.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader.gif
// module id = 578
// module chunks = 20